const getEnvVar = (key: string, required: boolean = true) => {
  const value = process.env[key];

  if (required && (value === undefined || value === '')) {
    throw new Error(`Env variable ${key} is required but not found or empty`);
  }

  return value || '';
};

const EMBED_URI_APP_ENV = getEnvVar('REACT_APP_EMBED_URI', false);
export { EMBED_URI_APP_ENV };
